'use client';

import ProductListContent from '@/components/sections/builder/elements/body/product-grid/client-content';

import SkeletonProductList from '@/components/sections/builder/elements/body/product-grid/skeleton';
import { ElementProps } from '@/components/sections/builder/types';
import { Suspense } from 'react';

export default function ElementContent({
  element,
  preview,
  host,
  theme,
  storeSetting,
}: ElementProps) {
  return (
    <Suspense
      fallback={
        <div className='theme_layout_page_width mx-auto duration-100'>
          <div className='mx-auto w-full max-w-sm'>
            <div className='space-y-4'>
              {Array.from({ length: 6 }).map((_, index) => (
                <SkeletonProductList key={index} />
              ))}
            </div>
          </div>
        </div>
      }
    >
      <ProductListContent
        element={element}
        preview={preview}
        host={host}
        theme={theme}
        storeSetting={storeSetting}
      />
    </Suspense>
  );
}
